

export const ThemeDark = {
  name: "dark",
  color: "#8f8f8f",
  text: "#fff",
  dash: {
    background: "#0E2954",
    text: "#fff"
  },
  menu: {
    main: "#27374D",
    contrast: "#0d0d0e",
  },
  table: {
    bg: "#27374D",
    line: {
      main: "#27374D",
      even: "#526D82"
    },
    border: "#27374D",
    text: {
      main: "#F1F4F9",
      hover: "#4C4A4A"
    },
    bghover: "#fff"
  },
  header: {
    text: "#fff",
    background: "#27374D",
  }
}
